import type React from 'react';
import { useEffect, useRef, useState } from 'react';

import { Tooltip } from '../Tooltip';

import { StyledTextOverflow } from './styles';

export const TextOverflow: React.FC<{ text: string; showTooltip?: boolean }> = ({ text, showTooltip = false }) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [isOverflow, setIsOverflow] = useState(false);

  useEffect(() => {
    if (textRef.current) {
      setIsOverflow(textRef.current.scrollWidth > textRef.current.clientWidth);
    }
  }, []);

  return (
    <Tooltip
      content={text}
      enabled={showTooltip || isOverflow}
      placement="top"
      className="text-overflow-tooltip"
      maxWidth={230}
    >
      <StyledTextOverflow ref={textRef}>{text}</StyledTextOverflow>
    </Tooltip>
  );
};
